module.exports = __webpack_public_path__ + "img/welding-9.6a31f646.jpg";